<template>
  <Layout>
    <div class="section  content is-size-7 has-text-white">
      <p class="is-size-5 has-text-primary">Zrušenie</p>
      <p>
        Predplatné si môžete zrušiť kedykoľvek na zákazníckej linke <a class="has-text-primary" href="tel:0313215999">0313215999</a> a cez e-mail <a class="has-text-primary" href="mailto:keepyoufit.sk@silverlines.info">keepyoufit.sk@silverlines.info</a> alebo stačí odoslať SMS správu v tvare "FIT STOP" na 7406 
      </p>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/layouts/Kyf'

export default {
  name: 'Deactivation',
  components: {
    Layout
  }
}
</script>




// WEBPACK FOOTER //
// src/components/LangKyf/SK/Deactivation.vue